import { preprocessMarkdownContent, processMarkdownText } from "./markdownProcessing";

/**
 * Process markdown content for clipboard copying, using shared processing logic
 * This removes tool references, fixes formatting, and processes Slack-style content
 */
export async function processMarkdownForClipboard(content: string): Promise<string> {
  if (typeof content !== "string" || content === "") {
    return "";
  }

  // Use shared preprocessing logic
  const preprocessedContent = await preprocessMarkdownContent(content);

  // Use shared processing chain (with empty sources array for clipboard)
  let processedText = processMarkdownText(preprocessedContent, []);

  // Remove source references for clipboard (they start with `††toolu and end with `)
  processedText = processedText.replace(/`††toolu[^`]*`/g, "");

  return processedText;
}